import PageProtectedLayout from "../../../components/Page/PageProtectedLayout";
import UserLabreportsDashboard from "./UserLabreportsDashboard";
import { useTranslation } from '../../../language';

export default function UserLabreportsWelcome() {
  const { t } = useTranslation();
  return (
    <PageProtectedLayout
      headline={t('lab_page_hl')}
      specify={t('lab_page_sp')}
    >
      <UserLabreportsDashboard />
    </PageProtectedLayout>
  );
}
